import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    EmptyState,
    BaasicButton
} from "core/components";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";

const FacilityOrderAdjustNextRunDatesTemplate = function ({ facilityOrderAdjustNextRunDatesViewStore }) {

    const {
        tableStore,
        routes,
        authorization,
        reloadTemplates,
    } = facilityOrderAdjustNextRunDatesViewStore;

    return (
        <React.Fragment>
            <ApplicationListLayout
                store={facilityOrderAdjustNextRunDatesViewStore}
                authorization={authorization}
            >
                <PageNavigation>
                <BaasicButton className="btn btn--base btn--primary" label={'Reload templates'} onClick={() => reloadTemplates()} disabled={!tableStore.hasSelectedItems} ></BaasicButton>               

                </PageNavigation>
                <Content emptyRenderer={renderEmpty(routes)}>
                    <div className="card--table">
                        <BaasicTable
                            authorization={authorization}
                            tableStore={tableStore}
                        />
                    </div>
                </Content>
            </ApplicationListLayout>
        </React.Fragment>
    );
};

function renderEmpty() {
    return (
        <EmptyState
            title="FACILITY_ORDER_TEMPLATE.LIST.EMPTY_STATE.TITLE"
        />
    );
}

FacilityOrderAdjustNextRunDatesTemplate.propTypes = {
    facilityOrderAdjustNextRunDatesViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderAdjustNextRunDatesTemplate);